import {useEffect} from "react";
import {Control, Controller} from "react-hook-form";
import {RadioButton} from "primereact/radiobutton";
import {classNames} from "primereact/utils";
import "./RadioButtonInput.scss";
import {RequestType} from "../../models/Request";

export interface RadioButtonInputProps {
    id: string;
    value: boolean | undefined;
    radioButtonValue1: string;
    radioButtonValue2: string;
    onValueChange: (property: string, value: boolean | undefined) => void;
    labelText: string;
    control: Control;
    setValue?: any;
    errors: any;
    rules?: any;
    disabled?: boolean;
    colorType?: string;
};

export const RadioButtonInput = (p: RadioButtonInputProps) => {
    const {
        id,
        value,
        radioButtonValue1,
        radioButtonValue2,
        onValueChange,
        labelText,
        control,
        setValue,
        errors,
        rules,
        disabled,
        colorType
    } = p;

    useEffect(() => {
        if (setValue) setValue(labelText, value)
    }, [value]);

    return (
        <div className="radiobutton-input">
            <label
                className={classNames("radiobutton-label", {
                    'p-error': errors[labelText], 
                })}
                htmlFor={id}
            >
                {labelText}
            </label>
            <div className="radiobutton-field-container">
                <div className="radiobutton-field">
                    <Controller
                        name={labelText}
                        control={control}
                        rules={rules}
                        render={({ field, fieldState }) => (
                            <RadioButton
                                {...field}
                                inputId="opt-1"
                                name={labelText}
                                value={value}
                                onChange={()=>{
                                    field.onChange(true);
                                    onValueChange(id, true)}}
                                className={classNames(
                                    { 'radiobutton-field' : colorType === undefined },
                                    { 'radiobutton-request-import-field': colorType === RequestType.Import },
                                    { 'radiobutton-request-export-field': colorType === RequestType.Export },
                                    { 'radiobutton-request-relocation-field': colorType === RequestType.Relocation },
                                    { 'p-invalid': fieldState.invalid }
                                )}
                                checked={value === true}
                                disabled={disabled}
                                />
                            )}
                    />
                    <label
                        htmlFor="opt-2"
                        className={classNames(
                                { 'radiobutton-field-label' : colorType === undefined },
                                { 'radiobutton-request-import-field-label': colorType === RequestType.Import },
                                { 'radiobutton-request-export-field-label': colorType === RequestType.Export },
                                { 'radiobutton-request-relocation-field-label': colorType === RequestType.Relocation },
                        )}
                    >
                        {radioButtonValue1}
                    </label>  
                </div>
                <div className="radiobutton-field">
                    <Controller
                        name={labelText}
                        control={control}
                        rules={rules}
                        render={({ field, fieldState }) => (
                            <RadioButton
                                {...field}
                                inputId="opt-2"
                                name={labelText}
                                value={value}
                                onChange={()=>{
                                    field.onChange(false);
                                    onValueChange(id, false)}
                                }
                                className={classNames(
                                    { 'radiobutton-field' : colorType === undefined },
                                    { 'radiobutton-request-import-field': colorType === RequestType.Import },
                                    { 'radiobutton-request-export-field': colorType === RequestType.Export },
                                    { 'radiobutton-request-relocation-field': colorType === RequestType.Relocation },
                                    { 'p-invalid': fieldState.invalid }
                                )}
                                checked={value === false}
                                disabled={disabled}
                                />
                            )}
                    />
                    <label
                        htmlFor="opt-2"
                        className={classNames(
                            { 'radiobutton-field-label' : colorType === undefined },
                            { 'radiobutton-request-import-field-label': colorType === RequestType.Import },
                            { 'radiobutton-request-export-field-label': colorType === RequestType.Export },
                            { 'radiobutton-request-relocation-field-label': colorType === RequestType.Relocation },
                        )}
                    >
                        {radioButtonValue2}
                    </label> 
                </div>
            </div>
        </div>
    );
};